import React, { Component } from "react";
import { FormGroup } from "react-bootstrap";
import DatePicker from "react-datepicker";
import moment from "moment";
import styles from "./DatePicker2.scss";
import "react-datepicker/dist/react-datepicker.css";

class DatePicker2 extends Component {
  constructor(props) {
    super(props);
    this.handleChange(props.input.value);
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(date) {
    const newDate = date ? moment(date).format("MM/DD/YYYY") : null;
    this.props.input.onChange(newDate);

    if (this.props.onSelectDate) {
      this.props.onSelectDate(newDate);
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.input.value !== this.props.input.value) {
      const newDate = nextProps.input.value
        ? moment(nextProps.input.value).format("MM/DD/YYYY")
        : null;
      this.props.input.onChange(newDate);

      if (this.props.onSelectDate) {
        this.props.onSelectDate(newDate);
      }
    }
  }

  render() {
    const {
      input,
      placeholder,
      name,
      minDate,
      meta: { touched, error, warning, valid }
    } = this.props;

    const validationState =
      (touched && valid && "success") ||
      (touched && error && "error") ||
      (touched && warning && "warning") ||
      null;

    return (
      <FormGroup
        validationState={validationState}
        style={{ textAlign: "left" }}
      >
        <DatePicker
          selected={input.value ? moment(input.value, "MM/DD/YYYY") : null}
          onChange={this.handleChange}
          placeholderText={placeholder}
          name={name}
          className={styles.input}
          onBlur={input.onBlur}
          dateFormat="MM/DD/YYYY"
          minDate={minDate}
          disabledKeyboardNavigation
        />
        {touched && error && <p className={styles.error}>{error}</p>}
      </FormGroup>
    );
  }
}

export default DatePicker2;



// WEBPACK FOOTER //
// ./src/components/common/datepicker/DatePicker2.js